import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import VoyageDecoration from "@/pages/VoyageDecoration";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/voyage-decoration" element={<VoyageDecoration />} />
            <Route path="/mentions-legales" element={<Legal kind="mentions-legales" />} />
            <Route path="/cgv" element={<Legal kind="cgv" />} />
            <Route path="/confidentialite" element={<Legal kind="confidentialite" />} />
            <Route path="/livraison-retours" element={<Legal kind="livraison-retours" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-left" duration={2500} toastOptions={{ style: { background: "#2F333A", color: "#F8F4EC", border: "1px solid rgba(201,161,92,0.35)", borderRadius: 0 } }} />
      </CartProvider>
    </div>
  );
}

export default App;
